export default "__VITE_PUBLIC_ASSET__b0988e15__"